<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>商品类型</span>
				<el-button class="button" @click='edit("")' type="success">新增商品类型</el-button>
			</div>
		</template>
		<div class="col">
			<el-table empty-text="暂无数据" v-loading="loading" :data="saleTypeData.filter(data => !search || data.product_sale_name.toLowerCase().includes(search.toLowerCase()))"
			 style="width: 100%;" :default-sort="sort" border highlight-current-row>
				<el-table-column prop="id" label="编号" sortable width="180">
				</el-table-column>
				<el-table-column label="商品类型名称">
					<template #default="scope">
						<span>{{scope.row.product_sale_name}}</span>
					</template>
				</el-table-column>
				<el-table-column align="right">
					<template #header>
						<el-input v-model="search" size="medium" placeholder="输入商品类型名称" />
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
						<el-button v-if="this.localGet('userId')==1" type="danger" size="medium" @click="destroy(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form :model="item" ref="form" :rules="rules" label-width="120px">
			<el-form-item label="商品类型名称" prop="product_sale_name">
				<el-input style="width: 200px;" v-model="item.product_sale_name" size="small" placeholder="商品类型名称"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
			<el-button size="mini" type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default{
		name:'ProductSaleType',
		data(){
			return {
				title: '新增商品类型',
				dialogFormVisible: false,
				loading:true,
				saleTypeData:[],
				search: '',
				sort: {
					prop: 'id',
					order: 'descending'
				},
				item:{
					product_sale_name:'',
					
				},
				rules:{
						product_sale_name: [{
						required: true,
						message: '请填写商品类型名称',
						trigger: 'blur'
					}],
				}
			}
		},
		methods: {
			edit(row) {
				this.dialogFormVisible = true;
				let temp = this.cloneObj(row);
				// console.log(temp)
				if (row) {
					this.title = '编辑商品类型';
					this.item = temp;
				} else {
					this.resetObj(this.item)
				}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			submit() {
				// console.log(this.item);
				// return false;
				this.$refs['form'].validate((valid) => {
					if (valid) {
			
						this.httpPost({
							url: '/admin/product/productSaleTypeUpdate',
							data: this.item
						}).then((re) => {
			
							// console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getProductSaleType();

						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			
			},
			destroy(index, row) {
				console.log(index, row)
				let id = row.id
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/product/productSaleTypeDelete', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getProductSaleType()
				})
			},
			getProductSaleType(){
					this.httpPost({
					url: '/admin/product/productSaleTypeList',
					data:{
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.saleTypeData = temp;
					this.loading = false;
				
				}).catch((err) => {
					this.loading = false;
				})
			},
		},
		created(){
			this.getProductSaleType();
		}
	}
</script>

<style>
</style>
